export default __webpack_public_path__ + "static/media/mod_OP_ENG.1d04bbc2.jpg";